import { Alert, AlertTitle, Stack, Typography } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import BenefitHint from '../../../component/benefitTabs/BenefitHint';
import ITLeasingConnectForm from './ITLeasingConnectForm';
import { ITLeasingLinks } from './links';
import { useITLeasingPrecondition } from './useITLeasingPrecondition';

interface ITLeasingConnectPanelProps {
  onConnected?: () => void;
}

const ITLeasingConnectPanel: React.FC<ITLeasingConnectPanelProps> = ({ onConnected }) => {
  const { t } = useTranslation('benefitsModule');
  const { isPreconditionMet } = useITLeasingPrecondition();

  return (
    <Stack
      spacing={2}
      sx={{
        alignSelf: 'center',
        alignItems: 'center',
        width: '60%',
      }}
    >
      <Typography variant="h1" gutterBottom>
        {t('IT_LEASING.connect.title')}
      </Typography>
      <Typography
        variant="body2"
        sx={{
          color: 'text.secondary',
          mb: 3,
        }}
      >
        {t('IT_LEASING.connect.description')}
      </Typography>
      {isPreconditionMet && (
        <Alert severity="info">
          <AlertTitle> {t('IT_LEASING.connect.alert.title')}</AlertTitle>
          {t('IT_LEASING.connect.alert.description')}
        </Alert>
      )}
      <ITLeasingConnectForm onSubmit={onConnected} />
      <BenefitHint
        title={t('IT_LEASING.hint.where.title')}
        description={
          <Typography
            variant="body2"
            sx={{
              color: 'text.secondary',
            }}
          >
            <Trans i18nKey="benefitsModule:IT_LEASING.hint.where.description" />
          </Typography>
        }
      />
      <BenefitHint
        title={t('IT_LEASING.hint.support.title')}
        description={
          <Typography
            variant="body2"
            sx={{
              color: 'text.secondary',
            }}
          >
            <Trans
              i18nKey="benefitsModule:IT_LEASING.hint.support.description"
              components={{
                supportEmail: <a href={ITLeasingLinks.HR_SUPPORT_MAIL_TO} />,
              }}
            />
          </Typography>
        }
      />
    </Stack>
  );
};

export default ITLeasingConnectPanel;
